import React from 'react';
import Button from '../../ui/Button';

const MarketerFAQ: React.FC = () => {
  return (
    <section id="faq" className="py-24 bg-slate-900 border-t border-slate-800">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-white text-center mb-12">Frequently Asked Questions</h2>
        
        <div className="space-y-8">
          <div>
            <h4 className="text-lg font-bold text-white mb-2">Where does the data come from?</h4>
            <p className="text-slate-400">We aggregate data from official state licensing boards and public records, then verify and enrich it with contact information monthly.</p>
          </div>
          
          <div>
            <h4 className="text-lg font-bold text-white mb-2">How fresh is the data?</h4>
            <p className="text-slate-400">License status is synced daily. Contact information is verified monthly. Much fresher than the 6-month-old data you get from legacy providers.</p>
          </div>
          
          <div>
            <h4 className="text-lg font-bold text-white mb-2">What professionals do you cover?</h4>
            <p className="text-slate-400">Real estate agents, insurance producers, attorneys, contractors (25+ trades), medical professionals, CPAs, and more. Over 13 million records across 15 major markets.</p>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-2">Can I integrate with my CRM?</h4>
            <p className="text-slate-400">Yes. Export CSV files or use our API (Growth plan and above) to connect with any CRM or outreach tool.</p>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-2">Is there a contract?</h4>
            <p className="text-slate-400">No. Month-to-month billing. Cancel anytime.</p>
          </div>
        </div>

        {/* FINAL CTA */}
        <div className="mt-24 text-center bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-12 border border-slate-700">
          <h2 className="text-3xl font-bold text-white mb-4">Stop Paying for Bad Data</h2>
          <p className="text-lg text-slate-400 mb-8 max-w-xl mx-auto">
            Join thousands of marketers who reach licensed professionals with verified contact info.
          </p>
          <Button size="lg" onClick={() => document.getElementById('pricing')?.scrollIntoView({behavior: 'smooth'})}>
            Start Your Free Trial
          </Button>
        </div>
      </div>
    </section>
  );
};

export default MarketerFAQ;